import React, { FC } from 'react';

import { useFlag } from '@modernloop/shared/feature-flag';

import { SourceType } from 'src/generated/mloop-graphql';

import CreateNoteTextField from 'src/entities/ActivityLogsList/CreateNoteTextField';
import MentionEditor from 'src/entities/ActivityLogsList/MentionEditor';

type Props = {
  sourceId: string;
  sourceType: SourceType;
  onSubmit: () => void;
  onChange: (value: string) => void;
  timeline?: boolean;
  aiEnabled?: boolean;
};

/**
 * Renders the note composer variant appropriate for the activity feed surface.
 */
const ActivityFeedComposer: FC<Props> = ({ sourceId, sourceType, onSubmit, onChange, timeline, aiEnabled = false }) => {
  const mentionsEnabled = useFlag('MENTIONS');

  if (timeline && mentionsEnabled) {
    return (
      <MentionEditor
        sourceId={sourceId}
        sourceType={sourceType}
        onSubmit={onSubmit}
        onChange={onChange}
        aiEnabled={aiEnabled}
      />
    );
  }

  return <CreateNoteTextField sourceId={sourceId} sourceType={sourceType} onSubmit={onSubmit} onChange={onChange} />;
};

export default ActivityFeedComposer;
